<template>
    <transition>
        <div class="filter-list-wrapper">
            <transition name="filter-transition">
                <div class="filter-list" v-show="open" ref="filterlist" :class="{'filter-list--offer-counter-fixed': fixCounter, 'filter-list--offer-counter-float': floatCounter}">
                    <div class="filter-list__header">
                        <div class="filter-list__header__icon">
                            <img src="../../../assets/img/icons/icon-filter-header.svg" alt="">
                        </div>
                        <h2 class="filter-list__header__text">
                            <offer-counter v-show="open"></offer-counter>
                        </h2>
                        <button class="filter-list__header__btn" @click="open = false">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.15 27.15"><path d="M16.26,13.57,26.59,3.24A1.9,1.9,0,0,0,23.9.56L13.57,10.89,3.24.56A1.88,1.88,0,0,0,.56.56a1.88,1.88,0,0,0,0,2.68L10.89,13.57.56,23.9a1.9,1.9,0,1,0,2.68,2.69L13.57,16.26,23.9,26.59a1.93,1.93,0,0,0,1.35.56,1.91,1.91,0,0,0,1.34-3.25Z"/></svg>
                        </button>
                    </div>
                    <div class="filter-list__nav">
                        <button v-for="(tab, tabKey) in tabs" :key="tabKey" :class="{'current': (currentTab == tabKey)}" @click="currentTab = tabKey" v-text="tab"></button>
                    </div>
                    <div class="filter-list__wrapper" :class="{'filter-list__wrapper--disable': false}">
                        <slot></slot>
                    </div>
                </div>
            </transition>

            <div class="filter-fab" @click="open = !open" v-if="ready && !open">
                <div class="filter-fab__text" v-if="toolTip">
                    <span v-text="toolTip"></span>
                </div>
                <div class="filter-fab__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35.97 29.92"><path d="M22.15,2.92a4.43,4.43,0,0,0-8.34,0H0v3H13.8a4.43,4.43,0,0,0,8.38,0H36v-3ZM18,7.34a2.89,2.89,0,1,1,2.89-2.88A2.88,2.88,0,0,1,18,7.34Z"/><path d="M28.48,10.5a4.44,4.44,0,0,0-4.17,2.94H0v3H24.3a4.43,4.43,0,0,0,8.38,0H36v-3H32.65A4.45,4.45,0,0,0,28.48,10.5Zm0,7.34A2.89,2.89,0,1,1,31.37,15,2.88,2.88,0,0,1,28.48,17.84Z"/><path d="M7.48,21a4.44,4.44,0,0,0-4.17,2.94H0v3H3.3a4.43,4.43,0,0,0,8.38,0H36v-3H11.65A4.45,4.45,0,0,0,7.48,21Zm0,7.34a2.89,2.89,0,1,1,2.89-2.88A2.88,2.88,0,0,1,7.48,28.34Z"/></svg>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import OfferCounter from './offer-counter.vue';
    import ScrolllMonitor from 'scrollmonitor';
export default {
    props: {
        title: {type: String, default: ''},
        tabs: {type: Array, default() {return [ ]}},
        toolTip: {type: String, default: null},
        ready: {type: Boolean, default: false}
    },
    mounted() {
        this.$on('close', () => {
            this.open = false;
        })

        this.$on('openView', () => {
            this.open = true;
        })

        this.scrollWatcher = ScrolllMonitor.create(this.$refs.filterlist, {top: 108, bottom: -108});
        window.addEventListener('resize', this.onResize.bind(this));

        this.$on('recalculate', () => {
            console.log('Recalculate scroll');
            this.$nextTick(() => {
                this.scrollWatcher.recalculateLocation();
            });
        });

        this.scrollWatcher.stateChange(() => {
            this.fixCounter = this.scrollWatcher.isAboveViewport;
        });

        this.scrollWatcher.exitViewport(() => {
            this.floatCounter = !this.scrollWatcher.isInViewport;
        });

        this.scrollWatcher.enterViewport(() => {
            this.floatCounter = !this.scrollWatcher.isInViewport;
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize.bind(this));
        this.scrollWatcher.destroy();
    },
    methods: {
        onResize() {
            this.$emit('recalculate')
        }  
    },
    data() {
        return {
            open: false,
            currentTab: 0,
            fixCounter: false,
            floatCounter: false,
            scrollWatcher: null
        }
    },
    watch: {
        currentTab() {
            this.$emit('tabchange', this.currentTab);
        },
        ready() {
            this.$emit('recalculate');
        },
        open() {
            this.$emit('open', this.open);
            if(this.open) {
                window.document.getElementsByTagName('body')[0].classList.add('noScroll');
            } else {
                window.document.getElementsByTagName('body')[0].classList.remove('noScroll');                
            }
        }
    },
    components: {
        'offer-counter': OfferCounter
    }
}
</script>
